import React, { FunctionComponent } from 'react';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import styles from './LinkedinPostCardMedia.module.scss';
import DefaultVideo from '../../assets/images/defaultVideo.png';
import { useModal } from 'app/context/Modal';
interface Props {
  attachments: any[];
}

const renderImage = (
  item: any,
  class_name: string,
  handelOpenImage: (index?: number) => void,
  handelOpenVideo: (index?: number) => void,
  is_last_item: boolean = false,
  remaining_items?: number,
) => (
  <div className={class_name}>
    <img
      onClick={() => {
        !item.thumbnail ? handelOpenImage() : handelOpenVideo();
      }}
      src={
        item.type === 'VIDEO'
          ? !item.thumbnail
            ? DefaultVideo
            : item.thumbnail
          : item.url
      }
      alt="image"
    />
    {item.thumbnail && (
      <button className={styles.VideoBtn}>
        <PlayArrowIcon />
      </button>
    )}
    {is_last_item && remaining_items && (
      <div
        onClick={() => {
          !item.thumbnail ? handelOpenImage() : handelOpenVideo();
        }}
        className={styles.lastItem}
      >
        +{remaining_items}
      </div>
    )}
  </div>
);

const LinkedinPostCardMedia: FunctionComponent<Props> = ({ attachments }) => {
  const modal = useModal();
  const handelOpenImage = (index = 0) => {
    modal.show({
      imageUrls: attachments?.map((i) => ({
        url: i.url,
        type: i.type,
      })),
      imageIndex: index,
    });
  };
  const handelOpenVideo = (index = 0) => {
    modal.show({
      imageUrls: attachments,
      imageIndex: index,
    });
  };
  return (
    <div className={styles.LinkedinPostCardMedia}>
      <div className={styles.postCardContainer}>
        <div style={{ display: 'flex', gap: '5px' }}>
          {renderImage(
            attachments[0],
            styles.postImage,
            () => handelOpenImage(0),
            () => handelOpenVideo(0),
          )}
          {attachments.length === 2 &&
            renderImage(
              attachments[1],
              styles.postImage,
              () => handelOpenImage(1),
              () => handelOpenVideo(1),
            )}
        </div>

        {attachments.length >= 3 && (
          <div style={{ display: 'flex', gap: '3px', marginTop: '3px' }}>
            {attachments.slice(1, 4).map((item, index) =>
              renderImage(
                item,
                styles.postImageGrid,
                () => handelOpenImage(index + 1),
                () => handelOpenVideo(index + 1),
                index === 2 && attachments.length > 4,
                index === 2 && attachments.length > 4
                  ? attachments.length - 4
                  : undefined,
              ),
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LinkedinPostCardMedia;
